import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUserSettings } from 'src/recoil/selectors/permissionsSelector';
import { RootState } from '../../app/store';

// ENG-8377 - This redux slice allows us to trigger an update for the recoil user atom in
// functions that are not part of a hook
interface IRecoilUserSyncSlice {
  payload: IUserSettings | undefined;
}
const initialState: IRecoilUserSyncSlice = {
  payload: undefined,
};
export const recoilUserSyncSlice = createSlice({
  name: 'recoilUserSync',
  initialState,
  reducers: {
    toggleRecoilUserSync: (
      state: IRecoilUserSyncSlice,
      action: PayloadAction<IUserSettings | undefined>
    ) => {
      state.payload = action.payload;
    },
  },
});

export const selectRecoilUserSync = (state: RootState) => state.recoilUserSync;

export const { toggleRecoilUserSync } = recoilUserSyncSlice.actions;

export const recoilUserSyncReducer = recoilUserSyncSlice.reducer;
